import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

export const accountExistenceCheckApi = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunctionUnAuth(data, apiConstants.AUTH.ACCOUNT_EXISTENCE_CHECK)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}